<template>
  <div>
    <b-form-group
      v-if="show_verbose"
      :label="$t('toolbar.alternativeNames.defaultSingularName')"
      label-for="input-verbose_name"
      label-cols="4"
      label-cols-sm="4"
      class="label"
    >
      <b-form-input
        id="input-verbose_name"
        name="input-verbose_name"
        v-model="alternative_name.verbose_name"
        readonly
        size="sm"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      v-if="show_verbose"
      :label="$t('toolbar.alternativeNames.defaultPluralName')"
      label-for="input-verbose_name_plural"
      label-cols="4"
      label-cols-sm="4"
      class="label"
    >
      <b-form-input
        id="input-verbose_name_plural"
        name="input-verbose_name_plural"
        v-model="alternative_name.verbose_name_plural"
        readonly
        size="sm"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      :label="$t('toolbar.alternativeNames.singularArticle')"
      label-for="input-singular_article"
      label-cols="4"
      label-cols-sm="4"
      class="label"
    >
      <b-form-select
        id="input-singular_article"
        name="input-singular_article"
        v-model="$v.alternative_name.singular_article.$model"
        :state="validateState('singular_article')"
        aria-describedby="input-singular_article-live-feedback"
        size="sm"
      >
        <template #first>
          <b-form-select-option value="">{{
            $t("toolbar.alternativeNames.selectArticle")
          }}</b-form-select-option>
        </template>
        <b-form-select-option
          v-for="article in singularArticles"
          :key="article"
          :value="article"
          >{{ article }}</b-form-select-option
        >
      </b-form-select>
      <b-form-invalid-feedback id="input-singular_article-live-feedback">{{
        $t("toolbar.alternativeNames.mustSelectArticle")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('toolbar.alternativeNames.singularName')"
      label-for="input-visible_name"
      label-cols="4"
      label-cols-sm="4"
      class="label"
    >
      <b-form-input
        id="input-visible_name"
        name="input-visible_name"
        v-model="$v.alternative_name.visible_name.$model"
        :state="validateState('visible_name')"
        aria-describedby="input-visible_name-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-visible_name-live-feedback">{{
        $t("reusable.common.minLength", { min: 3 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('toolbar.alternativeNames.pluralArticle')"
      label-for="input-plural_article"
      label-cols="4"
      label-cols-sm="4"
      class="label"
    >
      <b-form-select
        id="input-plural_article"
        name="input-plural_article"
        v-model="$v.alternative_name.plural_article.$model"
        :state="validateState('plural_article')"
        aria-describedby="input-plural_article-live-feedback"
        size="sm"
      >
        <template #first>
          <b-form-select-option value="">{{
            $t("toolbar.alternativeNames.selectArticle")
          }}</b-form-select-option>
        </template>
        <b-form-select-option
          v-for="article in pluralArticles"
          :key="article"
          :value="article"
          >{{ article }}</b-form-select-option
        >
      </b-form-select>
      <b-form-invalid-feedback id="input-plural_article-live-feedback">{{
        $t("toolbar.alternativeNames.mustSelectArticle")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('toolbar.alternativeNames.pluralName')"
      label-for="input-visible_name_plural"
      label-cols="4"
      label-cols-sm="4"
      class="label"
    >
      <b-form-input
        id="input-visible_name_plural"
        name="input-visible_name_plural"
        v-model="$v.alternative_name.visible_name_plural.$model"
        :state="validateState('visible_name_plural')"
        aria-describedby="input-visible_name_plural-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-visible_name_plural-live-feedback">{{
        $t("reusable.common.minLength", { min: 4 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <!-- <b-form-group
      label="Nombre corto"
      label-for="input-short_name"
      label-cols="4"
      label-cols-sm="4"
      class="label"
    >
      <b-form-input
        id="input-short_name"
        name="input-short_name"
        v-model="$v.alternative_name.short_name.$model"
        :state="validateState('short_name')"
        aria-describedby="input-short_name-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-short_name-live-feedback"
        >Este campo debe tener al menos 1 caracter.</b-form-invalid-feedback
      >
    </b-form-group> -->
    <b-form-group
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2"
    >
      <ModificationDate :Information="alternative_name"></ModificationDate>
    </b-form-group>

    <div class="row">
      <div
        v-if="show_delete_button && !isNaN(this.alternative_name.id)"
        class="col"
        style="text-align: left"
      >
        <b-button
          class="mr-1"
          size="sm"
          variant="danger"
          @click="deleteAlternativeName"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
      <div v-if="show_save_button" class="col" style="text-align: right">
        <b-button class="mr-1" size="sm" @click="save">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { generateUniqueId } from "@/utils/utils";
import * as names from "@/store/names";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { toast } from "@/utils/utils";
export default {
  name: "AlternativeNameForm",
  mixins: [validationMixin],
  components: {
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
  },
  props: {
    AlternativeName: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          verbose_name_plural: "",
          verbose_name: "",
          visible_name: "",
          visible_name_plural: "",
          plural_article: null,
          singular_article: null,
          short_name: "",
          updated_by: null,
          update_date: null,
        };
      },
    },
    show_verbose: {
      type: Boolean,
      default: false,
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
    show_delete_button: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      alternative_name: { ...this.AlternativeName },
      translation_id: null,
    };
  },
  computed: {
    ...mapGetters({
      alternativeNamesTranslations: names.ALTERNATIVE_NAMES_TRANSLATIONS,
    }),
    currentLangCode() {
      return this.$i18n.locale;
    },
    singularArticles() {
      if (this.currentLangCode === "en") return ["the", "a", "an"];
      return ["el", "la"];
    },
    pluralArticles() {
      if (this.currentLangCode === "en") return ["the"];
      return ["los", "las"];
    },
  },
  validations: {
    alternative_name: {
      visible_name: {
        required,
        minLength: minLength(1),
      },
      visible_name_plural: {
        required,
        minLength: minLength(1),
      },
      short_name: {},
      singular_article: {},
      plural_article: {},
    },
  },
  created() {
    this.fetchTranslation();
  },
  methods: {
    fetchTranslation() {
      if (!this.alternative_name.language || isNaN(this.alternative_name.id))
        return;
      const existing = this.alternativeNamesTranslations.find(
        (t) =>
          t.alternative_name == this.alternative_name.id &&
          t.language == this.alternative_name.language
      );
      if (existing) {
        this.translation_id = existing.id;
        return;
      }
      this.$store
        .dispatch(names.FETCH_ALTERNATIVE_NAMES_TRANSLATIONS, true)
        .then((translations) => {
          const found = translations.find(
            (t) =>
              t.alternative_name == this.alternative_name.id &&
              t.language == this.alternative_name.language
          );
          if (found) {
            this.translation_id = found.id;
          }
        });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.alternative_name[name];
      return $dirty ? !$error : null;
    },
    save() {
      this.$v.alternative_name.$touch();
      if (this.$v.alternative_name.$anyError) {
        return;
      }
      if (isNaN(this.alternative_name.id)) {
        this.createAlternativeName();
      } else this.updateAlternativeName();
    },
    createAlternativeName() {
      // this.$store
      //   .dispatch(
      //     names.POST_ALTERNATIVE_NAME,
      //     this.alternative_name,
      //   )
      //   .then((response) => {
      //     toast("Tipo de Asignatura creada.");
      //     this.$emit("created", response);
      //   });
    },
    updateAlternativeName() {
      const translation_data = {
        alternative_name: this.alternative_name.id,
        language: this.alternative_name.language,
        visible_name: this.alternative_name.visible_name,
        visible_name_plural: this.alternative_name.visible_name_plural,
        singular_article: this.alternative_name.singular_article,
        plural_article: this.alternative_name.plural_article,
        short_name: this.alternative_name.short_name,
      };
      if (this.translation_id) {
        this.$store
          .dispatch(names.UPDATE_ALTERNATIVE_NAMES_TRANSLATION, {
            id: this.translation_id,
            ...translation_data,
          })
          .then(() => {
            toast(this.$t("toolbar.alternativeNames.updated"));
            this.$emit("updated", this.alternative_name);
          });
      } else {
        this.$store
          .dispatch(names.POST_ALTERNATIVE_NAMES_TRANSLATION, translation_data)
          .then((response) => {
            this.translation_id = response.id;
            toast(this.$t("toolbar.alternativeNames.updated"));
            this.$emit("updated", this.alternative_name);
          });
      }
    },
    deleteAlternativeName() {
      this.$swal({
        title: this.$t(
          "toolbar.alternativeNames.deleteAlternativeNameConfirmation"
        ),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          if (this.translation_id) {
            this.$store.dispatch(names.DELETE_ALTERNATIVE_NAMES_TRANSLATION, {
              alternative_names_translation_id: this.translation_id,
              alternative_name_id: this.alternative_name.id,
            });
          }
          this.$emit("deleted", this.alternative_name);
        }
      });
    },
  },
};
</script>

<style scoped>
</style>